const cursosSuperioresList = [
  // 01 - Educação
  { codigo: null, nome: "- - -" },
  { codigo: "0111C012", nome: "Ciência da educação - Bacharelado" },
  { codigo: "0111C014", nome: "Ciência da educação - Sequencial" },
  { codigo: "0111P013", nome: "Processos escolares - Tecnológico" },
  { codigo: "0111P022", nome: "Psicopedagogia - Bacharelado" },
  { codigo: "0111P024", nome: "Psicopedagogia - Sequencial" },
  { codigo: "0112E011", nome: "Educação infantil formação de professor - Licenciatura" },
  { codigo: "0113E011", nome: "Educação do campo formação de professor - Licenciatura" },
  { codigo: "0113E021", nome: "Educação especial formação de professor - Licenciatura" },
  { codigo: "0113E031", nome: "Educação indígena formação de professor - Licenciatura" },
  {
    codigo: "0113F011",
    nome: "Formação pedagógica de professor para a educação básica - Licenciatura",
  },
  {
    codigo: "0113F014",
    nome: "Formação pedagógica de professor para a educação básica - Sequencial",
  },
  { codigo: "0113P011", nome: "Pedagogia - Licenciatura" },
  { codigo: "0113P012", nome: "Pedagogia - Bacharelado" },
  { codigo: "0113P014", nome: "Pedagogia - Sequencial" },
  { codigo: "0114A011", nome: "Artes formação de professor - Licenciatura" },
  { codigo: "0114A014", nome: "Artes formação de professor - Sequencial" },
  { codigo: "0114A021", nome: "Artes visuais formação de professor - Licenciatura" },
  { codigo: "0114B011", nome: "Biologia formação de professor - Licenciatura" },
  { codigo: "0114C011", nome: "Ciências agrárias formação de professor - Licenciatura" },
  { codigo: "0114C021", nome: "Ciências naturais formação de professor - Licenciatura" },
  { codigo: "0114C031", nome: "Ciências sociais formação de professor - Licenciatura" },
  { codigo: "0114C041", nome: "Cinema e audiovisual formação de professor - Licenciatura" },
  { codigo: "0114C051", nome: "Computação formação de professor - Licenciatura" },
  { codigo: "0114D011", nome: "Dança formação de professor - Licenciatura" },
  { codigo: "0114E011", nome: "Economia doméstica formação de professor - Licenciatura" },
  {
    codigo: "0114E021",
    nome: "Educação do campo em áreas de conhecimento da educação básica formação de professor - Licenciatura",
  },
  { codigo: "0114E031", nome: "Educação física formação de professor - Licenciatura" },
  {
    codigo: "0114E041",
    nome: "Educação indígena em áreas de conhecimento da educação básica formação de professor - Licenciatura",
  },
  { codigo: "0114E051", nome: "Enfermagem formação de professor - Licenciatura" },
  {
    codigo: "0114E061",
    nome: "Ensino profissionalizante em área específica formação de professor - Licenciatura",
  },
  { codigo: "0114E071", nome: "Ensino religioso formação de professor - Licenciatura" },
  { codigo: "0114E081", nome: "Estatística formação de professor - Licenciatura" },
  { codigo: "0114F011", nome: "Filosofia formação de professor - Licenciatura" },
  { codigo: "0114F021", nome: "Física formação de professor - Licenciatura" },
  { codigo: "0114G011", nome: "Geografia formação de professor - Licenciatura" },
  { codigo: "0114H011", nome: "História formação de professor - Licenciatura" },
  { codigo: "0114M011", nome: "Matemática formação de professor - Licenciatura" },
  { codigo: "0114M021", nome: "Música formação de professor - Licenciatura" },
  { codigo: "0114P011", nome: "Psicologia formação de professor - Licenciatura" },
  { codigo: "0114Q011", nome: "Química formação de professor - Licenciatura" },
  { codigo: "0114T011", nome: "Teatro formação de professor - Licenciatura" },
  { codigo: "0115L011", nome: "Letras alemão formação de professor - Licenciatura" },
  { codigo: "0115L021", nome: "Letras espanhol formação de professor - Licenciatura" },
  { codigo: "0115L031", nome: "Letras francês formação de professor - Licenciatura" },
  { codigo: "0115L041", nome: "Letras inglês formação de professor - Licenciatura" },
  { codigo: "0115L051", nome: "Letras italiano formação de professor - Licenciatura" },
  { codigo: "0115L061", nome: "Letras japonês formação de professor - Licenciatura" },
  {
    codigo: "0115L071",
    nome: "Letras língua brasileira de sinais formação de professor - Licenciatura",
  },
  {
    codigo: "0115L081",
    nome: "Letras línguas estrangeiras clássicas formação de professor - Licenciatura",
  },
  { codigo: "0115L091", nome: "Letras linguística formação de professor - Licenciatura" },
  {
    codigo: "0115L101",
    nome: "Letras outras línguas estrangeiras modernas formação de professor - Licenciatura",
  },
  { codigo: "0115L111", nome: "Letras português alemão formação de professor - Licenciatura" },
  { codigo: "0115L121", nome: "Letras português espanhol formação de professor - Licenciatura" },
  { codigo: "0115L131", nome: "Letras português formação de professor - Licenciatura" },
  { codigo: "0115L141", nome: "Letras português francês formação de professor - Licenciatura" },
  { codigo: "0115L151", nome: "Letras português inglês formação de professor - Licenciatura" },
  { codigo: "0115L161", nome: "Letras português italiano formação de professor - Licenciatura" },
  { codigo: "0115L171", nome: "Letras português japonês formação de professor - Licenciatura" },
  {
    codigo: "0115L181",
    nome: "Letras português língua brasileira de sinais formação de professor - Licenciatura",
  },
  {
    codigo: "0115L191",
    nome: "Letras português línguas estrangeiras clássicas formação de professor - Licenciatura",
  },
  {
    codigo: "0115L201",
    nome: "Letras português outras línguas estrangeiras modernas formação de professor - Licenciatura",
  },
  { codigo: "0115L211", nome: "Letras tradutor e intérprete formação de professor - Licenciatura" },
  { codigo: "0188P011", nome: "Programas interdisciplinares abrangendo educação - Licenciatura" },
  { codigo: "0188P012", nome: "Programas interdisciplinares abrangendo educação - Bacharelado" },
  { codigo: "0188P013", nome: "Programas interdisciplinares abrangendo educação - Tecnoló}gico" },

  // 02 - Artes e humanidades
  { codigo: "0211A012", nome: "Animação - Bacharelado" },
  { codigo: "0211A013", nome: "Animação - Tecnológico" },
  { codigo: "0211A014", nome: "Animação - Sequencial" },
  { codigo: "0211C012", nome: "Cinema e audiovisual - Bacharelado" },
  { codigo: "0211C013", nome: "Cinema e audiovisual - Tecnológico" },
  { codigo: "0211C014", nome: "Cinema e audiovisual - Sequencial" },
  { codigo: "0211C023", nome: "Comunicação assistiva - Tecnológico" },
  { codigo: "0211D012", nome: "Design gráfico - Bacharelado" },
  { codigo: "0211D013", nome: "Design gráfico - Tecnológico" },
  { codigo: "0211D014", nome: "Design gráfico - Sequencial" },
  { codigo: "0211F012", nome: "Fotografia - Bacharelado" },
  { codigo: "0211F013", nome: "Fotografia - Tecnológico" },
  { codigo: "0211F014", nome: "Fotografia - Sequencial" },
  { codigo: "0211P012", nome: "Produção audiovisual - Bacharelado" },
  { codigo: "0211P013", nome: "Produção audiovisual - Tecnológico" },
  { codigo: "0211P014", nome: "Produção audiovisual - Sequencial" },
  { codigo: "0211P023", nome: "Produção cênica - Tecnológico" },
  { codigo: "0211P032", nome: "Produção cultural - Bacharelado" },
  { codigo: "0211P033", nome: "Produção cultural - Tecnológico" },
  { codigo: "0211P034", nome: "Produção cultural - Sequencial" },
  { codigo: "0211P043", nome: "Produção fonográfica - Tecnológico" },
  { codigo: "0211P052", nome: "Produção multimídia - Bacharelado" },
  { codigo: "0211P053", nome: "Produção multimídia - Tecnológico" },
  { codigo: "0211P054", nome: "Produção multimídia - Sequencial" },
  { codigo: "0212D012", nome: "Desenho industrial - Bacharelado" },
  { codigo: "0212D022", nome: "Design - Bacharelado" },
  { codigo: "0212D023", nome: "Design - Tecnológico" },
  { codigo: "0212D032", nome: "Design de interiores - Bacharelado" },
  { codigo: "0212D033", nome: "Design de interiores - Tecnológico" },
  { codigo: "0212D034", nome: "Design de interiores - Sequencial" },
  { codigo: "0212D042", nome: "Design de produto - Bacharelado" },
  { codigo: "0212D043", nome: "Design de produto - Tecnológico" },
  { codigo: "0212D044", nome: "Design de produto - Sequencial" },
  { codigo: "0212M012", nome: "Moda - Bacharelado" },
  { codigo: "0212M013", nome: "Moda - Tecnológico" },
  { codigo: "0212M014", nome: "Moda - Sequencial" },
  { codigo: "0213A012", nome: "Artes - Bacharelado" },
  { codigo: "0213A013", nome: "Artes - Tecnológico" },
  { codigo: "0213A014", nome: "Artes - Sequencial" },
  { codigo: "0213A022", nome: "Artes plásticas - Bacharelado" },
  { codigo: "0213A023", nome: "Artes plásticas - Tecnológico" },
  { codigo: "0213A024", nome: "Artes plásticas - Sequencial" },
  { codigo: "0213A032", nome: "Artes visuais - Bacharelado" },
  { codigo: "0213A033", nome: "Artes visuais - Tecnológico" },
  { codigo: "0213H012", nome: "História da arte - Bacharelado" },
  { codigo: "0214F013", nome: "Fabricação de instrumentos musicais não industrial - Tecnológico" },
  { codigo: "0215A012", nome: "Artes cênicas - Bacharelado" },
  { codigo: "0215A013", nome: "Artes cênicas - Tecnológico" },
  { codigo: "0215D012", nome: "Dança - Bacharelado" },
  { codigo: "0215D013", nome: "Dança - Tecnológico" },
  { codigo: "0215M012", nome: "Música - Bacharelado" },
  { codigo: "0215M013", nome: "Música - Tecnológico" },
  { codigo: "0215M014", nome: "Música - Sequencial" },
  { codigo: "0215T012", nome: "Teatro - Bacharelado" },
  { codigo: "0215T013", nome: "Teatro - Tecnológico" },
  { codigo: "0221C012", nome: "Ciências da religião - Bacharelado" },
  { codigo: "0221T012", nome: "Teologia - Bacharelado" },
  { codigo: "0221T013", nome: "Teologia - Tecnológico" },
  { codigo: "0221T014", nome: "Teologia - Sequencial" },
  { codigo: "0222A012", nome: "Arqueologia - Bacharelado" },
  { codigo: "0222A013", nome: "Arqueologia - Tecnológico" },
  { codigo: "0222C012", nome: "Conservação e restauro - Bacharelado" },
  { codigo: "0222C013", nome: "Conservação e restauro - Tecnológico" },
  { codigo: "0222H012", nome: "História - Bacharelado" },
  { codigo: "0222H014", nome: "História - Sequencial" },
  { codigo: "0223F012", nome: "Filosofia - Bacharelado" },
  { codigo: "0223F014", nome: "Filosofia - Sequencial" },
  { codigo: "0231L012", nome: "Letras alemão - Bacharelado" },
  { codigo: "0231L023", nome: "Letras escrita criativa - Tecnológico" },
  { codigo: "0231L024", nome: "Letras escrita criativa - Sequencial" },
  { codigo: "0231L032", nome: "Letras espanhol - Bacharelado" },
  { codigo: "0231L034", nome: "Letras espanhol - Sequencial" },
  { codigo: "0231L042", nome: "Letras francês - Bacharelado" },
  { codigo: "0231L052", nome: "Letras inglês - Bacharelado" },
  { codigo: "0231L054", nome: "Letras inglês - Sequencial" },
  { codigo: "0231L062", nome: "Letras italiano - Bacharelado" },
  { codigo: "0231L072", nome: "Letras japonês - Bacharelado" },
  { codigo: "0231L082", nome: "Letras língua brasileira de sinais - Bacharelado" },
  { codigo: "0231L083", nome: "Letras língua brasileira de sinais - Tecnológico" },
  { codigo: "0231L084", nome: "Letras língua brasileira de sinais - Sequencial" },
  { codigo: "0231L092", nome: "Letras línguas estrangeiras clássicas - Bacharelado" },
  { codigo: "0231L094", nome: "Letras línguas estrangeiras clássicas - Sequencial" },
  { codigo: "0231L102", nome: "Letras linguística - Bacharelado" },
  { codigo: "0231L112", nome: "Letras outras línguas estrangeiras modernas - Bacharelado" },
  { codigo: "0231L122", nome: "Letras português - Bacharelado" },
  { codigo: "0231L124", nome: "Letras português - Sequencial" },
  { codigo: "0231L132", nome: "Letras português alemão - Bacharelado" },
  { codigo: "0231L142", nome: "Letras português espanhol - Bacharelado" },
  { codigo: "0231L152", nome: "Letras português francês - Bacharelado" },
  { codigo: "0231L162", nome: "Letras português inglês - Bacharelado" },
  { codigo: "0231L172", nome: "Letras português italiano - Bacharelado" },
  { codigo: "0231L182", nome: "Letras português japonês - Bacharelado" },
  { codigo: "0231L192", nome: "Letras português língua brasileira de sinais - Bacharelado" },
  { codigo: "0231L202", nome: "Letras português línguas estrangeiras clássicas - Bacharelado" },
  {
    codigo: "0231L212",
    nome: "Letras português outras línguas estrangeiras modernas - Bacharelado",
  },
  { codigo: "0231L222", nome: "Letras tradutor e intérprete - Bacharelado" },
  { codigo: "0231L223", nome: "Letras tradutor e intérprete - Tecnológico" },
  { codigo: "0231L224", nome: "Letras tradutor e intérprete - Sequencial" },
  {
    codigo: "0288P012",
    nome: "Programas interdisciplinares abrangendo artes e humanidades - Bacharelado",
  },
  {
    codigo: "0288P014",
    nome: "Programas interdisciplinares abrangendo artes e humanidades - Sequen}cial",
  },

  // 03 - Ciências sociais, comunicação e informação
  { codigo: "0311E012", nome: "Economia - Bacharelado" },
  { codigo: "0311E014", nome: "Economia - Sequencial" },
  { codigo: "0312A012", nome: "Antropologia - Bacharelado" },
  { codigo: "0312A014", nome: "Antropologia - Sequencial" },
  { codigo: "0312C012", nome: "Ciência política - Bacharelado" },
  { codigo: "0312C014", nome: "Ciência política - Sequencial" },
  { codigo: "0312C022", nome: "Ciências sociais - Bacharelado" },
  { codigo: "0312C023", nome: "Ciências sociais - Tecnológico" },
  { codigo: "0312C024", nome: "Ciências sociais - Sequencial" },
  { codigo: "0312G012", nome: "Geografia - Bacharelado" },
  { codigo: "0312R012", nome: "Relações internacionais - Bacharelado" },
  { codigo: "0312R014", nome: "Relações internacionais - Sequencial" },
  { codigo: "0312S012", nome: "Sociologia - Bacharelado" },
  { codigo: "0312S014", nome: "Sociologia - Sequencial" },
  { codigo: "0313P012", nome: "Psicologia - Bacharelado" },
  { codigo: "0313P014", nome: "Psicologia - Sequencial" },
  { codigo: "0321C012", nome: "Comunicação social - Bacharelado" },
  { codigo: "0321J012", nome: "Jornalismo - Bacharelado" },
  { codigo: "0321J014", nome: "Jornalismo - Sequencial" },
  { codigo: "0321P012", nome: "Produção editorial - Bacharelado" },
  { codigo: "0321P013", nome: "Produção editorial - Tecnológico" },
  { codigo: "0321P014", nome: "Produção editorial - Sequencial" },
  { codigo: "0321R012", nome: "Rádio, TV e internet - Bacharelado" },
  { codigo: "0321R013", nome: "Rádio, TV e internet - Tecnológico" },
  { codigo: "0321R014", nome: "Rádio, TV e internet - Sequencial" },
  { codigo: "0322A012", nome: "Arquivologia - Bacharelado" },
  { codigo: "0322B012", nome: "Biblioteconomia - Bacharelado" },
  { codigo: "0322G012", nome: "Gestão da informação - Bacharelado" },
  { codigo: "0322G014", nome: "Gestão da informação - Sequencial" },
  { codigo: "0322M012", nome: "Museologia - Bacharelado" },
  { codigo: "0322M013", nome: "Museologia - Tecnológico" },
  { codigo: "0322M014", nome: "Museologia - Sequencial" },
  {
    codigo: "0388P012",
    nome: "Programas interdisciplinares abrangendo ciências sociais, jornalismo e informação - Bacharelado",
  },
  {
    codigo: "0388P014",
    nome: "Programas interdisciplinares abrangendo ciências sociais, jornalismo e informação - Sequen}cial",
  },

  // 04 - Negócios, administração e direito
  { codigo: "0411C012", nome: "Contabilidade - Bacharelado" },
  { codigo: "0411C013", nome: "Contabilidade - Tecnológico" },
  { codigo: "0411C014", nome: "Contabilidade - Sequencial" },
  { codigo: "0411G013", nome: "Gestão fiscal e tributária - Tecnológico" },
  { codigo: "0412G012", nome: "Gestão financeira - Bacharelado" },
  { codigo: "0412G013", nome: "Gestão financeira - Tecnológico" },
  { codigo: "0412G014", nome: "Gestão financeira - Sequencial" },
  { codigo: "0412S013", nome: "Seguros - Tecnológico" },
  { codigo: "0412S014", nome: "Seguros - Sequencial" },
  { codigo: "0413A012", nome: "Administração - Bacharelado" },
  { codigo: "0413A014", nome: "Administração - Sequencial" },
  { codigo: "0413A022", nome: "Administração pública - Bacharelado" },
  { codigo: "0413A023", nome: "Administração pública - Tecnológico" },
  { codigo: "0413A024", nome: "Administração pública - Sequencial" },
  { codigo: "0413C012", nome: "Comércio exterior - Bacharelado" },
  { codigo: "0413C013", nome: "Comércio exterior - Tecnológico" },
  { codigo: "0413C014", nome: "Comércio exterior - Sequencial" },
  { codigo: "0413E012", nome: "Empreendedorismo - Bacharelado" },
  { codigo: "0413E013", nome: "Empreendedorismo - Tecnológico" },
  { codigo: "0413E014", nome: "Empreendedorismo - Sequencial" },
  { codigo: "0413G013", nome: "Gestão da produção - Tecnológico" },
  { codigo: "0413G014", nome: "Gestão da produção - Sequencial" },
  { codigo: "0413G023", nome: "Gestão da qualidade - Tecnológico" },
  { codigo: "0413G024", nome: "Gestão da qualidade - Sequencial" },
  { codigo: "0413G032", nome: "Gestão da saúde - Bacharelado" },
  { codigo: "0413G033", nome: "Gestão da saúde - Tecnológico" },
  { codigo: "0413G034", nome: "Gestão da saúde - Sequencial" },
  { codigo: "0413G042", nome: "Gestão de cooperativas - Bacharelado" },
  { codigo: "0413G043", nome: "Gestão de cooperativas - Tecnológico" },
  { codigo: "0413G044", nome: "Gestão de cooperativas - Sequencial" },
  { codigo: "0413G052", nome: "Gestão de negócios - Bacharelado" },
  { codigo: "0413G053", nome: "Gestão de negócios - Tecnológico" },
  { codigo: "0413G054", nome: "Gestão de negócios - Sequencial" },
  { codigo: "0413G062", nome: "Gestão de negócios internacionais - Bacharelado" },
  { codigo: "0413G064", nome: "Gestão de negócios internacionais - Sequencial" },
  { codigo: "0413G073", nome: "Gestão de pessoas - Tecnológico" },
  { codigo: "0413G074", nome: "Gestão de pessoas - Sequencial" },
  { codigo: "0413G083", nome: "Gestão de serviços - Tecnológico" },
  { codigo: "0413G084", nome: "Gestão de serviços - Sequencial" },
  { codigo: "0413G092", nome: "Gestão do agronegócio - Bacharelado" },
  { codigo: "0413G093", nome: "Gestão do agronegócio - Tecnológico" },
  { codigo: "0413G094", nome: "Gestão do agronegócio - Sequencial" },
  { codigo: "0413G103", nome: "Gestão estratégica - Tecnológico" },
  { codigo: "0413G104", nome: "Gestão estratégica - Sequencial" },
  { codigo: "0413G113", nome: "Gestão hospitalar - Tecnológico" },
  { codigo: "0413G114", nome: "Gestão hospitalar - Sequencial" },
  { codigo: "0413G122", nome: "Gestão pública - Bacharelado" },
  { codigo: "0413G123", nome: "Gestão pública - Tecnológico" },
  { codigo: "0413G124", nome: "Gestão pública - Sequencial" },
  { codigo: "0413L012", nome: "Logística - Bacharelado" },
  { codigo: "0413L013", nome: "Logística - Tecnológico" },
  { codigo: "0413L014", nome: "Logística - Sequencial" },
  { codigo: "0414M012", nome: "Marketing - Bacharelado" },
  { codigo: "0414M013", nome: "Marketing - Tecnológico" },
  { codigo: "0414M014", nome: "Marketing - Sequencial" },
  { codigo: "0414P012", nome: "Publicidade e propaganda - Bacharelado" },
  { codigo: "0414P013", nome: "Publicidade e propaganda - Tecnológico" },
  { codigo: "0414P014", nome: "Publicidade e propaganda - Sequencial" },
  { codigo: "0414R012", nome: "Relações públicas - Bacharelado" },
  { codigo: "0414R013", nome: "Relações públicas - Tecnológico" },
  { codigo: "0414R014", nome: "Relações públicas - Sequencial" },
  { codigo: "0415S012", nome: "Secretariado - Bacharelado" },
  { codigo: "0415S013", nome: "Secretariado - Tecnológico" },
  { codigo: "0415S014", nome: "Secretariado - Sequencial" },
  { codigo: "0416G013", nome: "Gestão comercial - Tecnológico" },
  { codigo: "0416G014", nome: "Gestão comercial - Sequencial" },
  { codigo: "0416N012", nome: "Negócios imobiliários - Bacharelado" },
  { codigo: "0416N013", nome: "Negócios imobiliários - Tecnológico" },
  { codigo: "0416N014", nome: "Negócios imobiliários - Sequencial" },
  { codigo: "0421D012", nome: "Direito - Bacharelado" },
  { codigo: "0421D013", nome: "Direito - Tecnológico" },
  { codigo: "0421D014", nome: "Direito - Sequencial" },
  { codigo: "0421M013", nome: "Mediação - Tecnológico" },
  { codigo: "0421S013", nome: "Serviços jurídicos e cartoriais - Tecnológico" },
  { codigo: "0421S014", nome: "Serviços jurídicos e cartoriais - Sequencial" },
  {
    codigo: "0488P012",
    nome: "Programas interdisciplinares abrangendo negócios, administração e direito - Bacharelado",
  },
  {
    codigo: "0488P013",
    nome: "Programas interdisciplinares abrangendo negócios, administração e direito - Tecnoló}gico",
  },

  // 05 - Ciências naturais, matemática e estatística
  { codigo: "0511B012", nome: "Biologia - Bacharelado" },
  { codigo: "0511B014", nome: "Biologia - Sequencial" },
  { codigo: "0512B012", nome: "Bioquímica - Bacharelado" },
  { codigo: "0512B022", nome: "Biotecnologia - Bacharelado" },
  { codigo: "0512B023", nome: "Biotecnologia - Tecnológico" },
  { codigo: "0512B024", nome: "Biotecnologia - Sequencial" },
  { codigo: "0512T013", nome: "Toxicologia - Tecnológico" },
  { codigo: "0521C012", nome: "Ciências ambientais - Bacharelado" },
  { codigo: "0521C014", nome: "Ciências ambientais - Sequencial" },
  { codigo: "0521E012", nome: "Ecologia - Bacharelado" },
  { codigo: "0531Q012", nome: "Química - Bacharelado" },
  { codigo: "0531Q013", nome: "Química - Tecnológico" },
  { codigo: "0531Q022", nome: "Química industrial e tecnológica - Bacharelado" },
  { codigo: "0531Q023", nome: "Química industrial e tecnológica - Tecnológico" },
  { codigo: "0531Q024", nome: "Química industrial e tecnológica - Sequencial" },
  { codigo: "0532G012", nome: "Geofísica - Bacharelado" },
  { codigo: "0532G022", nome: "Geologia - Bacharelado" },
  { codigo: "0532G033", nome: "Geoprocessamento - Tecnológico" },
  { codigo: "0532M012", nome: "Meteorologia - Bacharelado" },
  { codigo: "0532O012", nome: "Oceanografia - Bacharelado" },
  { codigo: "0533A012", nome: "Astronomia - Bacharelado" },
  { codigo: "0533F012", nome: "Física - Bacharelado" },
  { codigo: "0533F022", nome: "Física aplicada - Bacharelado" },
  { codigo: "0533F024", nome: "Física aplicada - Sequencial" },
  { codigo: "0533F032", nome: "Física médica - Bacharelado" },
  { codigo: "0541M012", nome: "Matemática - Bacharelado" },
  { codigo: "0541M014", nome: "Matemática - Sequencial" },
  { codigo: "0541M022", nome: "Matemática aplicada e computacional - Bacharelado" },
  { codigo: "0542C012", nome: "Ciências atuariais - Bacharelado" },
  { codigo: "0542E012", nome: "Estatística - Bacharelado" },
  { codigo: "0542E014", nome: "Estatística - Sequencial" },
  {
    codigo: "0588P012",
    nome: "Programas interdisciplinares abrangendo ciências naturais, matemática e estatística - Bacharelado",
  },
  {
    codigo: "0588P013",
    nome: "Programas interdisciplinares abrangendo ciências naturais, matemática e estatística - Tecnológico",
  },
  {
    codigo: "0588P014",
    nome: "Programas interdisciplinares abrangendo ciências naturais, matemática e estatística - Sequencial",
  },

  // 06 - Computação e Tecnologias da Informação e Comunicação (TIC)
  { codigo: "0612B013", nome: "Banco de dados - Tecnológico" },
  { codigo: "0612B014", nome: "Banco de dados - Sequencial" },
  { codigo: "0612D012", nome: "Defesa cibernética - Bacharelado" },
  { codigo: "0612D013", nome: "Defesa cibernética - Tecnológico" },
  { codigo: "0612G013", nome: "Gestão da tecnologia da informação - Tecnológico" },
  { codigo: "0612G014", nome: "Gestão da tecnologia da informação - Sequencial" },
  { codigo: "0612R012", nome: "Redes de computadores - Bacharelado" },
  { codigo: "0612R013", nome: "Redes de computadores - Tecnológico" },
  { codigo: "0612R014", nome: "Redes de computadores - Sequencial" },
  { codigo: "0613E012", nome: "Engenharia de software - Bacharelado" },
  { codigo: "0613E013", nome: "Engenharia de software - Tecnológico" },
  { codigo: "0613E014", nome: "Engenharia de software - Sequencial" },
  { codigo: "0613J012", nome: "Jogos digitais - Bacharelado" },
  { codigo: "0613J013", nome: "Jogos digitais - Tecnológico" },
  { codigo: "0613J014", nome: "Jogos digitais - Sequencial" },
  { codigo: "0614C012", nome: "Ciência da computação - Bacharelado" },
  { codigo: "0614C013", nome: "Ciência da computação - Tecnológico" },
  { codigo: "0614C014", nome: "Ciência da computação - Sequencial" },
  { codigo: "0614I012", nome: "Inteligência artificial - Bacharelado" },
  { codigo: "0614I013", nome: "Inteligência artificial - Tecnológico" },
  { codigo: "0615S013", nome: "Segurança da informação - Tecnológico" },
  { codigo: "0615S014", nome: "Segurança da informação - Sequencial" },
  { codigo: "0615S022", nome: "Sistemas de informação - Bacharelado" },
  { codigo: "0615S023", nome: "Sistemas de informação - Tecnológico" },
  { codigo: "0615S024", nome: "Sistemas de informação - Sequencial" },
  { codigo: "0615S032", nome: "Sistemas para internet - Bacharelado" },
  { codigo: "0615S033", nome: "Sistemas para internet - Tecnológico" },
  { codigo: "0615S034", nome: "Sistemas para internet - Sequencial" },
  { codigo: "0616I013", nome: "Internet das coisas - Tecnológico" },
  { codigo: "0616S013", nome: "Sistemas embarcados - Tecnológico" },
  { codigo: "0617A013", nome: "Agrocomputação - Tecnológico" },
  { codigo: "0617C012", nome: "Ciência de dados - Bacharelado" },
  { codigo: "0617C013", nome: "Ciência de dados - Tecnológico" },
  {
    codigo: "0617C022",
    nome: "Computação e Tecnologias da Informação e Comunicação (TIC) em biociências e saúde - Bacharelado",
  },
  {
    codigo: "0617C023",
    nome: "Computação e Tecnologias da Informação e Comunicação (TIC) em biociências e saúde - Tecnológico",
  },
  { codigo: "0617C032", nome: "Criação digital - Bacharelado" },
  { codigo: "0617C033", nome: "Criação digital - Tecnológico" },
  {
    codigo: "0688P012",
    nome: "Programas interdisciplinares abrangendo computação e Tecnologias da Informação e Comunicação (TIC) - Bacharelado",
  },
  {
    codigo: "0688P013",
    nome: "Programas interdisciplinares abrangendo computação e Tecnologias da Informação e Comunicação (TIC) - Tecnológico",
  },

  // 07 - Engenharia, produção e construção
  { codigo: "0711B013", nome: "Biocombustíveis - Tecnológico" },
  { codigo: "0711E012", nome: "Engenharia bioquímica - Bacharelado" },
  { codigo: "0711E022", nome: "Engenharia de bioprocessos - Bacharelado" },
  { codigo: "0711E032", nome: "Engenharia de biotecnologia - Bacharelado" },
  { codigo: "0711E042", nome: "Engenharia de nanotecnologia - Bacharelado" },
  { codigo: "0711E052", nome: "Engenharia química - Bacharelado" },
  { codigo: "0712E012", nome: "Engenharia ambiental - Bacharelado" },
  { codigo: "0712E022", nome: "Engenharia ambiental e sanitária - Bacharelado" },
  { codigo: "0712G012", nome: "Gestão ambiental - Bacharelado" },
  { codigo: "0712G013", nome: "Gestão ambiental - Tecnológico" },
  { codigo: "0712G014", nome: "Gestão ambiental - Sequencial" },
  { codigo: "0712G023", nome: "Gestão de resíduos - Tecnológico" },
  { codigo: "0712G024", nome: "Gestão de resíduos - Sequencial" },
  { codigo: "0712S013", nome: "Saneamento ambiental - Tecnológico" },
  { codigo: "0713E013", nome: "Eletrotécnica industrial - Tecnológico" },
  { codigo: "0713E023", nome: "Energias renováveis - Tecnológico" },
  { codigo: "0713E032", nome: "Engenharia bioenergética - Bacharelado" },
  { codigo: "0713E042", nome: "Engenharia de energia - Bacharelado" },
  { codigo: "0713E052", nome: "Engenharia elétrica - Bacharelado" },
  { codigo: "0713E062", nome: "Engenharia nuclear - Bacharelado" },
  { codigo: "0713R013", nome: "Refrigeração e climatização - Tecnológico" },
  { codigo: "0713S012", nome: "Sistemas elétricos - Bacharelado" },
  { codigo: "0713S013", nome: "Sistemas elétricos - Tecnológico" },
  { codigo: "0713S014", nome: "Sistemas elétricos - Sequencial" },
  { codigo: "0714A013", nome: "Automação industrial - Tecnológico" },
  { codigo: "0714A014", nome: "Automação industrial - Sequencial" },
  { codigo: "0714E013", nome: "Eletrônica industrial - Tecnológico" },
  { codigo: "0714E022", nome: "Engenharia acústica - Bacharelado" },
  { codigo: "0714E032", nome: "Engenharia biomédica - Bacharelado" },
  { codigo: "0714E042", nome: "Engenharia de computação - Bacharelado" },
  { codigo: "0714E052", nome: "Engenharia de controle e automação - Bacharelado" },
  { codigo: "0714E062", nome: "Engenharia de informação - Bacharelado" },
  { codigo: "0714E072", nome: "Engenharia de telecomunicações - Bacharelado" },
  { codigo: "0714E082", nome: "Engenharia eletrônica - Bacharelado" },
  { codigo: "0714E092", nome: "Engenharia mecatrônica - Bacharelado" },
  { codigo: "0714G013", nome: "Gestão de telecomunicações - Tecnológico" },
  { codigo: "0714G014", nome: "Gestão de telecomunicações - Sequencial" },
  { codigo: "0714M013", nome: "Mecatrônica industrial - Tecnológico" },
  { codigo: "0714M014", nome: "Mecatrônica industrial - Sequencial" },
  { codigo: "0714R013", nome: "Redes de telecomunicações - Tecnológico" },
  { codigo: "0714S013", nome: "Sistemas biomédicos - Tecnológico" },
  { codigo: "0714S023", nome: "Sistemas de telecomunicações - Tecnológico" },
  { codigo: "0714S024", nome: "Sistemas de telecomunicações - Sequencial" },
  { codigo: "0714T013", nome: "Telemática - Tecnológico" },
  { codigo: "0714T014", nome: "Telemática - Sequencial" },
  { codigo: "0715E012", nome: "Engenharia física - Bacharelado" },
  { codigo: "0715E022", nome: "Engenharia mecânica - Bacharelado" },
  { codigo: "0715E032", nome: "Engenharia metalúrgica - Bacharelado" },
  { codigo: "0715F013", nome: "Fabricação mecânica - Tecnológico" },
  { codigo: "0715M013", nome: "Manutenção industrial - Tecnológico" },
  { codigo: "0715M014", nome: "Manutenção industrial - Sequencial" },
  { codigo: "0715M023", nome: "Mecânica de precisão - Tecnológico" },
  { codigo: "0715P013", nome: "Processos metalúrgicos - Tecnológico" },
  { codigo: "0715P014", nome: "Processos metalúrgicos - Sequencial" },
  { codigo: "0715S013", nome: "Soldagem - Tecnológico" },
  { codigo: "0715S014", nome: "Soldagem - Sequencial" },
  { codigo: "0716A013", nome: "Aeroespacial - Tecnológico" },
  { codigo: "0716C013", nome: "Construção naval - Tecnológico" },
  { codigo: "0716E012", nome: "Engenharia aeroespacial - Bacharelado" },
  { codigo: "0716E022", nome: "Engenharia aeronáutica - Bacharelado" },
  { codigo: "0716E023", nome: "Engenharia aeronáutica - Tecnológico" },
  { codigo: "0716E032", nome: "Engenharia automotiva - Bacharelado" },
  { codigo: "0716E042", nome: "Engenharia ferroviária e metroviária - Bacharelado" },
  { codigo: "0716E052", nome: "Engenharia naval - Bacharelado" },
  { codigo: "0716M013", nome: "Manutenção de aeronaves - Tecnológico" },
  { codigo: "0716M014", nome: "Manutenção de aeronaves - Sequencial" },
  { codigo: "0716S013", nome: "Sistemas automotivos - Tecnológico" },
  { codigo: "0716S023", nome: "Sistemas de navegação fluvial - Tecnológico" },
  { codigo: "0721A012", nome: "Alimentos - Bacharelado" },
  { codigo: "0721A013", nome: "Alimentos - Tecnológico" },
  { codigo: "0721A014", nome: "Alimentos - Sequencial" },
  { codigo: "0721E012", nome: "Engenharia de alimentos - Bacharelado" },
  { codigo: "0721L012", nome: "Laticínios - Bacharelado" },
  { codigo: "0721L013", nome: "Laticínios - Tecnológico" },
  { codigo: "0721P013", nome: "Processamento de carnes - Tecnológico" },
  { codigo: "0721P023", nome: "Produção de cachaça - Tecnológico" },
  { codigo: "0721P033", nome: "Produção sucroalcooleira - Tecnológico" },
  { codigo: "0721P034", nome: "Produção sucroalcooleira - Sequencial" },
  { codigo: "0721P043", nome: "Produção de cerveja - Tecnológico" },
  { codigo: "0722C013", nome: "Cerâmica - Tecnológico" },
  { codigo: "0722C023", nome: "Ciências dos materiais - Tecnológico" },
  { codigo: "0722C024", nome: "Ciências dos materiais - Sequencial" },
  { codigo: "0722E012", nome: "Engenharia de materiais - Bacharelado" },
  { codigo: "0722P013", nome: "Papel e celulose - Tecnológico" },
  { codigo: "0722P022", nome: "Polímeros - Bacharelado" },
  { codigo: "0722P023", nome: "Polímeros - Tecnológico" },
  { codigo: "0722P033", nome: "Produção joalheira - Tecnológico" },
  { codigo: "0722P043", nome: "Produção moveleira - Tecnológico" },
  { codigo: "0723E012", nome: "Engenharia têxtil - Bacharelado" },
  { codigo: "0723P013", nome: "Produção de vestuário - Tecnológico" },
  { codigo: "0723P022", nome: "Produção têxtil - Bacharelado" },
  { codigo: "0723P023", nome: "Produção têxtil - Tecnológico" },
  { codigo: "0724E012", nome: "Engenharia de minas - Bacharelado" },
  { codigo: "0724E022", nome: "Engenharia de petróleo - Bacharelado" },
  { codigo: "0724E032", nome: "Engenharia geológica - Bacharelado" },
  { codigo: "0724M013", nome: "Mineração - Tecnológico" },
  { codigo: "0724P013", nome: "Petróleo e gás - Tecnológico" },
  { codigo: "0724R013", nome: "Rochas ornamentais - Tecnológico" },
  { codigo: "0725E012", nome: "Engenharia de manufatura - Bacharelado" },
  { codigo: "0725E013", nome: "Engenharia de manufatura - Tecnológico" },
  { codigo: "0725E022", nome: "Engenharia de produção - Bacharelado" },
  { codigo: "0725E032", nome: "Engenharia industrial - Bacharelado" },
  { codigo: "0725P013", nome: "Produção gráfica - Tecnológico" },
  { codigo: "0725P023", nome: "Produção industrial - Tecnológico" },
  { codigo: "0731A013", nome: "Agrimensura - Tecnológico" },
  { codigo: "0731A022", nome: "Arquitetura e urbanismo - Bacharelado" },
  { codigo: "0731A023", nome: "Arquitetura e urbanismo - Tecnológico" },
  { codigo: "0731A024", nome: "Arquitetura e urbanismo - Sequencial" },
  { codigo: "0731E012", nome: "Engenharia cartográfica - Bacharelado" },
  { codigo: "0731E022", nome: "Engenharia de agrimensura - Bacharelado" },
  { codigo: "0731E024", nome: "Engenharia de agrimensura - Sequencial" },
  { codigo: "0731E032", nome: "Engenharia de agrimensura e cartográfica - Bacharelado" },
  { codigo: "0732C013", nome: "Construção de edifícios - Tecnológico" },
  { codigo: "0732C023", nome: "Controle de obras - Tecnológico" },
  { codigo: "0732C024", nome: "Controle de obras - Sequencial" },
  { codigo: "0732E012", nome: "Engenharia civil - Bacharelado" },
  { codigo: "0732E022", nome: "Engenharia de recursos hídricos - Bacharelado" },
  { codigo: "0732E032", nome: "Engenharia de transportes - Bacharelado" },
  { codigo: "0732E042", nome: "Engenharia portuária - Bacharelado" },
  { codigo: "0732E053", nome: "Estradas - Tecnológico" },
  { codigo: "0732G013", nome: "Gestão de recursos hídricos - Tecnológico" },
  { codigo: "0732M013", nome: "Material de construção - Tecnológico" },
  {
    codigo: "0788P012",
    nome: "Programas interdisciplinares abrangendo engenharia, produção e construção - Bacharelado",
  },

  // 08 - Agricultura, silvicultura, pesca e veterinária
  { codigo: "0811A012", nome: "Agroecologia - Bacharelado" },
  { codigo: "0811A013", nome: "Agroecologia - Tecnológico" },
  { codigo: "0811A022", nome: "Agroindústria - Bacharelado" },
  { codigo: "0811A023", nome: "Agroindústria - Tecnológico" },
  { codigo: "0811A024", nome: "Agroindústria - Sequencial" },
  { codigo: "0811A032", nome: "Agronegócio - Bacharelado" },
  { codigo: "0811A033", nome: "Agronegócio - Tecnológico" },
  { codigo: "0811A042", nome: "Agronomia - Bacharelado" },
  { codigo: "0811A043", nome: "Agronomia - Tecnológico" },
  { codigo: "0811A053", nome: "Agropecuária - Tecnológico" },
  { codigo: "0811C013", nome: "Cafeicultura - Tecnológico" },
  { codigo: "0811E012", nome: "Engenharia agrícola - Bacharelado" },
  { codigo: "0811E013", nome: "Engenharia agrícola - Tecnológico" },
  { codigo: "0811E022", nome: "Engenharia de biossistemas - Bacharelado" },
  { codigo: "0811F013", nome: "Fruticultura - Tecnológico" },
  { codigo: "0811F014", nome: "Fruticultura - Sequencial" },
  { codigo: "0811I013", nome: "Irrigação e drenagem - Tecnológico" },
  { codigo: "0811M013", nome: "Manejo da produção agrícola - Tecnológico" },
  { codigo: "0811V012", nome: "Viticultura e enologia - Bacharelado" },
  { codigo: "0811V013", nome: "Viticultura e enologia - Tecnológico" },
  { codigo: "0811Z012", nome: "Zootecnia - Bacharelado" },
  { codigo: "0811Z013", nome: "Zootecnia - Tecnológico" },
  { codigo: "0811Z014", nome: "Zootecnia - Sequencial" },
  { codigo: "0812H013", nome: "Horticultura - Tecnológico" },
  { codigo: "0821E012", nome: "Engenharia florestal - Bacharelado" },
  { codigo: "0821E013", nome: "Engenharia florestal - Tecnológico" },
  { codigo: "0821S013", nome: "Silvicultura - Tecnológico" },
  { codigo: "0831A012", nome: "Aquicultura - Bacharelado" },
  { codigo: "0831A013", nome: "Aquicultura - Tecnológico" },
  { codigo: "0831A014", nome: "Aquicultura - Sequencial" },
  { codigo: "0831E012", nome: "Engenharia de pesca - Bacharelado" },
  { codigo: "0831P013", nome: "Produção pesqueira - Tecnológico" },
  { codigo: "0841M012", nome: "Medicina veterinária - Bacharelado" },
  { codigo: "0841M013", nome: "Medicina veterinária - Tecnológico" },
  { codigo: "0841M014", nome: "Medicina veterinária - Sequencial" },
  {
    codigo: "0888P012",
    nome: "Programas interdisciplinares abrangendo agricultura, silvicultura, pesca e veterinária - Bacharelado",
  },

  // 09 - Saúde e bem-estar
  { codigo: "0911O012", nome: "Odontologia - Bacharelado" },
  { codigo: "0911O014", nome: "Odontologia - Sequencial" },
  { codigo: "0912M012", nome: "Medicina - Bacharelado" },
  { codigo: "0912M013", nome: "Medicina - Tecnológico" },
  { codigo: "0912M014", nome: "Medicina - Sequencial" },
  { codigo: "0913E012", nome: "Enfermagem - Bacharelado" },
  { codigo: "0913E013", nome: "Enfermagem - Tecnológico" },
  { codigo: "0913E014", nome: "Enfermagem - Sequencial" },
  { codigo: "0914A013", nome: "Análises clínicas e toxicológicas - Tecnológico" },
  { codigo: "0914A014", nome: "Análises clínicas e toxicológicas - Sequencial" },
  { codigo: "0914B012", nome: "Biomedicina - Bacharelado" },
  { codigo: "0914B014", nome: "Biomedicina - Sequencial" },
  { codigo: "0914O013", nome: "Oftálmica - Tecnológico" },
  { codigo: "0914O022", nome: "Optometria - Bacharelado" },
  { codigo: "0914O023", nome: "Optometria - Tecnológico" },
  { codigo: "0914P013", nome: "Prótese e órtese - Tecnológico" },
  { codigo: "0914P014", nome: "Prótese e órtese - Sequencial" },
  { codigo: "0914R013", nome: "Radiologia - Tecnológico" },
  { codigo: "0914R014", nome: "Radiologia - Sequencial" },
  { codigo: "0915E012", nome: "Educação física - Bacharelado" },
  { codigo: "0915E014", nome: "Educação física - Sequencial" },
  { codigo: "0915F012", nome: "Fisioterapia - Bacharelado" },
  { codigo: "0915F022", nome: "Fonoaudiologia - Bacharelado" },
  { codigo: "0915N012", nome: "Nutrição - Bacharelado" },
  { codigo: "0915N013", nome: "Nutrição - Tecnológico" },
  { codigo: "0915N014", nome: "Nutrição - Sequencial" },
  { codigo: "0915P012", nome: "Podologia - Bacharelado" },
  { codigo: "0915P013", nome: "Podologia - Tecnológico" },
  { codigo: "0915T012", nome: "Terapia ocupacional - Bacharelado" },
  { codigo: "0916F012", nome: "Farmácia - Bacharelado" },
  { codigo: "0916F013", nome: "Farmácia - Tecnológico" },
  { codigo: "0916F014", nome: "Farmácia - Sequencial" },
  { codigo: "0917M012", nome: "Musicoterapia - Bacharelado" },
  { codigo: "0917P012", nome: "Práticas integrativas - Bacharelado" },
  { codigo: "0917P013", nome: "Práticas integrativas - Tecnológico" },
  { codigo: "0917P014", nome: "Práticas integrativas - Sequencial" },
  { codigo: "0918S012", nome: "Saúde coletiva - Bacharelado" },
  { codigo: "0918S013", nome: "Saúde coletiva - Tecnológico" },
  { codigo: "0918S014", nome: "Saúde coletiva - Sequencial" },
  { codigo: "0918S022", nome: "Saúde pública - Bacharelado" },
  { codigo: "0918S023", nome: "Saúde pública - Tecnológico" },
  { codigo: "0918S024", nome: "Saúde pública - Sequencial" },
  { codigo: "0921A014", nome: "Assistência a idosos e a deficientes - Sequencial" },
  { codigo: "0921G012", nome: "Gerontologia - Bacharelado" },
  { codigo: "0921G013", nome: "Gerontologia - Tecnológico" },
  { codigo: "0921G014", nome: "Gerontologia - Sequencial" },
  { codigo: "0923S012", nome: "Serviço social - Bacharelado" },
  { codigo: "0923S013", nome: "Serviço social - Tecnológico" },
  { codigo: "0923S014", nome: "Serviço social - Sequencial" },
  {
    codigo: "0988P012",
    nome: "Programas interdisciplinares abrangendo saúde e bem-estar - Bacharelado",
  },
  {
    codigo: "0988P013",
    nome: "Programas interdisciplinares abrangendo saúde e bem-estar - Tecnológico",
  },
  {
    codigo: "0988P014",
    nome: "Programas interdisciplinares abrangendo saúde e bem-estar - Sequencial",
  },

  // 10 - Serviços
  { codigo: "1011E012", nome: "Economia doméstica - Bacharelado" },
  { codigo: "1012E012", nome: "Estética e cosmética - Bacharelado" },
  { codigo: "1012E013", nome: "Estética e cosmética - Tecnológico" },
  { codigo: "1012E014", nome: "Estética e cosmética - Sequencial" },
  { codigo: "1013G012", nome: "Gastronomia - Bacharelado" },
  { codigo: "1013G013", nome: "Gastronomia - Tecnológico" },
  { codigo: "1013G014", nome: "Gastronomia - Sequencial" },
  { codigo: "1014F013", nome: "Formação de técnicos e treinadores esportivos - Tecnológico" },
  { codigo: "1014F014", nome: "Formação de técnicos e treinadores esportivos - Sequencial" },
  { codigo: "1014G012", nome: "Gestão desportiva e de lazer - Bacharelado" },
  { codigo: "1014G013", nome: "Gestão desportiva e de lazer - Tecnológico" },
  { codigo: "1014G014", nome: "Gestão desportiva e de lazer - Sequencial" },
  { codigo: "1015E013", nome: "Eventos - Tecnológico" },
  { codigo: "1015E014", nome: "Eventos - Sequencial" },
  { codigo: "1015H012", nome: "Hotelaria - Bacharelado" },
  { codigo: "1015H013", nome: "Hotelaria - Tecnológico" },
  { codigo: "1015H014", nome: "Hotelaria - Sequencial" },
  { codigo: "1015T012", nome: "Turismo - Bacharelado" },
  { codigo: "1015T013", nome: "Turismo - Tecnológico" },
  { codigo: "1015T014", nome: "Turismo - Sequencial" },
  { codigo: "1022S012", nome: "Segurança no trabalho - Bacharelado" },
  { codigo: "1022S013", nome: "Segurança no trabalho - Tecnológico" },
  { codigo: "1022S014", nome: "Segurança no trabalho - Sequencial" },
  { codigo: "1031C012", nome: "Ciências militares - Bacharelado" },
  { codigo: "1031C013", nome: "Ciências militares - Tecnológico" },
  { codigo: "1032I013", nome: "Investigação e perícia - Tecnológico" },
  { codigo: "1032I014", nome: "Investigação e perícia - Sequencial" },
  { codigo: "1032S013", nome: "Segurança no trânsito - Tecnológico" },
  { codigo: "1032S014", nome: "Segurança no trânsito - Sequencial" },
  { codigo: "1032S023", nome: "Segurança privada - Tecnológico" },
  { codigo: "1032S024", nome: "Segurança privada - Sequencial" },
  { codigo: "1032S032", nome: "Segurança pública - Bacharelado" },
  { codigo: "1032S033", nome: "Segurança pública - Tecnológico" },
  { codigo: "1032S034", nome: "Segurança pública - Sequencial" },
  { codigo: "1032S043", nome: "Serviços penais - Tecnológico" },
  { codigo: "1032S044", nome: "Serviços penais - Sequencial" },
  { codigo: "1041C012", nome: "Ciências aeronáuticas - Bacharelado" },
  { codigo: "1041C013", nome: "Ciências aeronáuticas - Tecnológico" },
  { codigo: "1041C014", nome: "Ciências aeronáuticas - Sequencial" },
  { codigo: "1041G013", nome: "Gestão portuária - Tecnológico" },
  { codigo: "1041G014", nome: "Gestão portuária - Sequencial" },
  { codigo: "1041T013", nome: "Transporte aéreo - Tecnológico" },
  { codigo: "1041T023", nome: "Transporte terrestre - Tecnológico" },
  { codigo: "1041T024", nome: "Transporte terrestre - Sequencial" },
  { codigo: "1088P013", nome: "Programas interdisciplinares abrangendo serviços - Tecnológico" },
];

export default cursosSuperioresList;
